import React, { lazy, Suspense, useEffect } from 'react';
import { Route, Switch, Redirect, useHistory } from 'react-router-dom';
import { Loader } from './components/components/Loader';
import { InnerGrid } from './components/components/InnerGrid';
import ReferralScreen from './components/Referral/ReferralScreen';
import { Maintenance } from './components/Maintenance/Maintenance';
import {AccessibilityContainer} from "./components/components/AccessibilityContainer";

const Main = lazy(() => import('./components/Main/Main'));
const ErrorScreen = lazy(() => import('./components/Error/ErrorScreen'));
const SuccessPage = lazy(() => import('./components/Success/SuccessPage'));
const SavedQuote = lazy(() => import('./components/SavedQuote/SavedQuote'));

export const App = () => {
  const history = useHistory();
  useEffect(
    () =>
      history.listen(() => {
        if (history.action === 'POP') {
          history.go(0);
        }
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [history]
  );
  return (
    <Suspense
      fallback={
        <InnerGrid>
          <div />
          <Loader message="Please wait..." />
        </InnerGrid>
      }
    >
      <Switch>
        <Route exact path="/error">
          <ErrorScreen />
          <AccessibilityContainer />
        </Route>
        <Route exact path="/success">
          <SuccessPage />
          <AccessibilityContainer />
        </Route>
        <Route exact path="/referral">
          <ReferralScreen />
          <AccessibilityContainer />
        </Route>
        <Route exact path="/quoteSaved">
          <SavedQuote />
          <AccessibilityContainer />
        </Route>
        <Route exact path="/maintenance">
          <Maintenance />
        </Route>
        <Route path="/">
          <Main />
        </Route>
        <Redirect from="*" to="/" />
      </Switch>
    </Suspense>
  );
};
